import React, { useState, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';
import Logo from '../components/Logo';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import './Auth.css';

const Register = () => {
  const [formData, setFormData] = useState({ name: '', email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { register } = useContext(AuthContext);
  const toast = useToast();
  const navigate = useNavigate();

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(formData.name, formData.email, formData.password);
      toast.success('Welcome to Centre Techniques Pianos');
      navigate('/');
    } catch (error) {
      toast.error(error.response?.data?.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <Logo variant="mark" size={48} />
          <div className="auth-logo-text">
            <strong>Centre Techniques</strong>
            <small>Pianos</small>
          </div>
        </div>

        <h2>Create an account</h2>
        <p className="subtitle">Join our community of musicians</p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Full name</label>
            <input
              type="text" name="name" required
              placeholder="John Doe"
              value={formData.name} onChange={handleChange}
              autoFocus autoComplete="name"
            />
          </div>

          <div className="form-group">
            <label>Email address</label>
            <input
              type="email" name="email" required
              placeholder="you@example.com"
              value={formData.email} onChange={handleChange}
              autoComplete="email"
            />
          </div>

          <div className="form-group password-toggle">
            <label>Password</label>
            <input
              type={showPassword ? 'text' : 'password'}
              name="password" required minLength="6"
              placeholder="At least 6 characters"
              value={formData.password} onChange={handleChange}
              autoComplete="new-password"
            />
            <button type="button" onClick={() => setShowPassword(!showPassword)}>
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

          <button type="submit" className="btn btn-primary btn-block btn-lg" disabled={loading}>
            {loading ? 'Creating account...' : 'Create account'}
          </button>
        </form>

        <p className="auth-link">
          Already have an account? <Link to="/login">Sign in</Link>
        </p>
      </div>
    </div>
  );
};

export default Register;
